<template>
  <div class="opportunity-page">
    <main class="opportunity-content">
      <header class="op-hero">
        <div class="op-hero-copy">
          <h1>大宗商机</h1>
          <span class="op-rule" aria-hidden="true"></span>
          <p>海量真实可靠的贸易供应链商机，内贸 · 进口 · 出口，只等您来。</p>
        </div>

        <nav class="type_list" aria-label="选择商机业务类型">
          <button
            v-for="(item, i) in businessTypeList"
            :key="i"
            type="button"
            class="type_item"
            :class="{ active_type: activeType === item.key }"
            @click="changeType(item)"
          >{{ item.desc }}</button>
        </nav>
      </header>

      <section v-if="dataList.length" class="op-list" aria-label="商机列表">
        <article
          v-for="(item, i) in dataList"
          :key="i"
          class="op-item"
          @click="handleItem(item)"
        >
          <header class="op-item-head">
            <span class="op-no">{{ item.number || '—' }}号商讯</span>
            <span class="op-head-right">
              <span class="op-type">{{ getSelectDesc(item.businessType, businessTypeList, 'key', 'desc') }}</span>
              <van-icon name="arrow" class="op-arrow" />
            </span>
          </header>

          <h2 v-if="categoryText(item)" class="op-cat">{{ categoryText(item) }}</h2>

          <p v-if="item.estimatedQuantity" class="op-quantity">
            <span class="q-label">预计货量</span>
            <strong>{{ item.estimatedQuantity }}</strong>
            <span v-if="item.quantityUnit" class="q-unit">{{ item.quantityUnit }}</span>
          </p>

          <p v-if="settleList(item).length" class="op-settle">
            <span v-for="(side, s) in settleList(item)" :key="s" class="op-chip">
              <b>{{ side.label }}</b>{{ side.text }}
            </span>
          </p>
        </article>
      </section>

      <div v-else class="op-empty">
        <van-icon name="bulb-o" class="empty-icon" />
        <p>当前暂无商机</p>
        <span>可切换上方业务类型查看其他方向</span>
      </div>
    </main>
  </div>
</template>

<script>

  export default {
    data () {
      return {
        dataList: [],
        paymentOrderList: [
          {label: '预付款', value: '1'},
          {label: '装完货即付款', value: '2'},
          {label: '有账期', value: '3'}
        ],
        activeType: 'intradomestic',
        businessTypeList: [
          {key: 'intradomestic', desc: '内贸', icon: 'neimaozhan'},
          {key: 'import', desc: '进口', icon: 'jinchukoubu'},
          {key: 'export', desc: '出口', icon: 'neimaotie'}
        ],
      }
    },
    created () {
      this.getDataList()
      this.share()
    },
    methods: {
      share () {
        this.$api
          .get("/api/wechat/share/get", {
            url: window.location.origin,
          })
          .then((res) => {
            console.log('分享数据获取：', res.result)
            let that = this
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.result.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
              timestamp: res.result.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.result.nonceStr, // 必填，生成签名的随机串
              signature: res.result.signature, // 必填，签名，见附录1
              jsApiList: [
                "checkJsApi",
                "onMenuShareTimeline",
                "onMenuShareAppMessage",
                "onMenuShareQQ",
                "onMenuShareWeibo",
                "onMenuShareQZone",
                "hideMenuItems",
                "showMenuItems",
                "hideAllNonBaseMenuItem",
                "showAllNonBaseMenuItem",
                "translateVoice",
                "startRecord",
                "stopRecord",
                "onVoiceRecordEnd",
                "playVoice",
                "onVoicePlayEnd",
                "pauseVoice",
                "stopVoice",
                "uploadVoice",
                "downloadVoice",
                "chooseImage",
                "previewImage",
                "uploadImage",
                "downloadImage",
                "getNetworkType",
                "openLocation",
                "getLocation",
                "hideOptionMenu",
                "showOptionMenu",
                "closeWindow",
                'updateTimelineShareData',
                "scanQRCode",
                "chooseWXPay",
                "openProductSpecificView",
                "addCard",
                "chooseCard",
                "openCard",
              ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });

            wx.ready(function () {
              let shareUrl = window.location.origin + window.location.pathname + `#/opportunity?id=${that.$route.query.id}`
              let logo = 'http://www.zhongpukeji.cn/img/icon/opportunity.png'
              let title = '海量的真实可靠的贸易供应链商机只等您来。'
              let desc = '内贸，进口，出口\n农产品，化工，有色，电子，矿产……'
              wx.onMenuShareAppMessage({
                title, // 分享标题
                desc, // 分享描述
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: logo, // 分享图标
                success: function (res) {
                  console.log('分享回调onMenuShareAppMessage：', JSON.stringify(res))
                }
              });
              wx.onMenuShareTimeline({
                title, // 分享标题
                desc, // 分享描述
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: logo, // 分享图标
                success: function (res) {
                  console.log('分享回调onMenuShareTimeline：', JSON.stringify(res))
                }
              })
              wx.updateTimelineShareData({
                title, // 分享标题
                desc, // 分享描述
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: logo, // 分享图标
                success: function (res) {
                  console.log('分享回调updateTimelineShareData：', JSON.stringify(res))
                }
              })
              //分享给好友
              wx.updateAppMessageShareData({
                title, // 分享标题
                desc, // 分享描述
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: logo, // 分享图标
                success: function (res) {
                  console.log('分享回调updateAppMessageShareData：', JSON.stringify(res))
                }
              })
            });
            wx.error(function (res) {
              console.log('打印错误消息:', res.errMsg); //打印错误消息。及把 debug:false,设置为debug:ture就可以直接在网页上看到弹出的错误提示
            });

          })
      },
      getSelectDesc (value, list, id = 'id', name = 'name') {
        let ind = list.findIndex((item) => item[id] === value)
        if (ind > -1) {
          return list[ind][name]
        } else {
          return ''
        }
      },
      categoryText (item) {
        if (!item) return ''
        const parts = [item.commodityCategoryMajor, item.commodityCategoryMinor].filter((v) => v !== null && v !== undefined && String(v).trim() !== '')
        return parts.join(' · ')
      },
      settlementText (item, side) {
        if (!item) return ''
        const prefix = side === 'downstream' ? 'downstream' : 'upstream'
        const tokens = [
          item[`${prefix}SettlementMethods`],
          this.getSelectDesc(item[`${prefix}PaymentOrder`], this.paymentOrderList, 'value', 'label'),
          item[`${prefix}AdvancePercentage`] ? item[`${prefix}AdvancePercentage`] + '%' : ''
        ].filter((v) => v !== null && v !== undefined && String(v).trim() !== '')
        return tokens.join(' ')
      },
      settleList (item) {
        const list = [
          { label: '上游', text: this.settlementText(item, 'upstream') },
          { label: '下游', text: this.settlementText(item, 'downstream') }
        ]
        return list.filter((side) => side.text !== '')
      },
      changeType (item) {
        this.activeType = item.key
        this.getDataList()
      },
      handleItem (item) {
        this.$router.push({
          path: '/opportunity-info',
          query: { id: item.id }
        })
      },
      getDataList () {
        this.$api
        .post("/crmapi/crm/commercialOpportunity/guestList", {
          pageNum: 1,
            pageSize: 10,
            params: {},
            data: {
              businessType: this.activeType
            }
        }).then((res) => {
          if (res.code === 'C0000') {
            this.dataList = res.result.list || []
          }
        })
      },
    }
  }
</script>

<style lang="less" scoped>
@page-bg: #faf7f1;
@surface: #fffdfc;
@ink: #142033;
@body: #333a45;
@muted: #7f858d;
@brand: #ef4f16;
@brand-light: #f47a3c;
@brand-soft: #fff1e8;
@gold: #d7a34a;
@line: #e9e6e1;

button { margin: 0; padding: 0; border: 0; color: inherit; font: inherit; background: transparent; appearance: none; }
.opportunity-page { min-height: 100vh; color: @ink; background: @page-bg; font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif; }
.opportunity-content { max-width: 750px; margin: 0 auto; }

.op-hero { position: relative; padding: 42px 40px 40px; overflow: hidden; background: @page-bg; }
.op-hero::after { position: absolute; top: -40px; right: -160px; width: 520px; height: 430px; background: url("../assets/images/trade-compliance-hero.png") 70% 30% / 780px auto no-repeat; opacity: .16; content: ""; pointer-events: none; }
.op-hero-copy { position: relative; z-index: 1; }
.op-hero h1 { margin: 0; color: @ink; font-family: "Songti SC", "STSong", "SimSun", serif; font-size: 48px; font-weight: 800; line-height: 1.15; letter-spacing: 2px; }
.op-rule { display: block; width: 44px; height: 6px; margin-top: 20px; border-radius: 3px; background: @brand; }
.op-hero-copy p { margin: 20px 0 0; color: @muted; font-size: 28px; line-height: 1.6; letter-spacing: 1px; }

.type_list { position: relative; z-index: 1; display: flex; width: 100%; margin-top: 34px; padding: 8px; box-sizing: border-box; border-radius: 20px; background: @brand-soft; }
.type_item { display: flex; flex: 1; align-items: center; justify-content: center; height: 64px; border-radius: 14px; color: #8a6a55; font-size: 30px; font-weight: 500; transition: color .15s ease, background-color .15s ease; }
.type_item + .type_item { margin-left: 6px; }
.type_item.active_type { color: @brand; font-weight: 700; background: #fffdfc; box-shadow: 0 2px 8px rgba(239, 79, 22, .08); }

.op-list { margin-top: 0; border-top: 1px solid @line; background: @surface; }
.op-item { position: relative; padding: 36px 40px 34px; overflow: hidden; cursor: pointer; }
.op-item::after { position: absolute; right: 40px; bottom: 0; left: 40px; height: 1px; background: @line; content: ""; }
.op-item:last-child::after { display: none; }
.op-item:active { background: #fbf8f3; }

.op-item-head { display: flex; align-items: center; justify-content: space-between; }
.op-no { min-width: 0; overflow: hidden; color: @muted; font-size: 26px; text-overflow: ellipsis; white-space: nowrap; }
.op-head-right { display: flex; flex: 0 0 auto; align-items: center; margin-left: 16px; }
.op-type { padding: 4px 18px; box-sizing: border-box; border: 1px solid @line; border-radius: 8px; color: @muted; font-size: 24px; line-height: 1.5; }
.op-arrow { margin-left: 18px; color: #b8b4ac; font-size: 28px; }

.op-cat { margin: 18px 0 0; color: @ink; font-size: 34px; font-weight: 700; line-height: 1.4; word-break: break-all; }

.op-quantity { display: flex; flex-wrap: wrap; align-items: baseline; margin: 16px 0 0; }
.op-quantity .q-label { color: @muted; font-size: 26px; }
.op-quantity strong { margin-left: 18px; color: @brand; font-size: 40px; font-weight: 700; line-height: 1; overflow-wrap: anywhere; }
.op-quantity .q-unit { margin-left: 8px; color: @muted; font-size: 26px; }

.op-settle { display: flex; flex-wrap: wrap; gap: 14px; margin: 22px 0 0; }
.op-chip { display: inline-flex; align-items: baseline; max-width: 100%; padding: 8px 20px; box-sizing: border-box; border: 1px solid #efe9e1; border-radius: 10px; background: #f9f6f1; color: @body; font-size: 26px; line-height: 1.5; word-break: break-all; }
.op-chip b { margin-right: 12px; color: @ink; font-weight: 600; }

.op-empty { padding: 130px 40px 160px; box-sizing: border-box; border-top: 1px solid @line; background: @surface; text-align: center; }
.op-empty .empty-icon { color: #dcd6cd; font-size: 72px; }
.op-empty p { margin: 24px 0 0; color: @body; font-size: 30px; font-weight: 600; }
.op-empty span { display: block; margin-top: 12px; color: @muted; font-size: 20px; }

@media (max-width: 420px) {
  .op-hero { padding: 30px 22px 28px; }
  .op-hero h1 { font-size: 38px; }
  .op-rule { width: 36px; height: 5px; margin-top: 16px; }
  .op-hero-copy p { margin-top: 16px; font-size: 24px; }
  .type_list { margin-top: 26px; }
  .type_item { height: 56px; font-size: 28px; }

  .op-item { padding: 28px 22px 26px; }
  .op-item::after { right: 22px; left: 22px; }
  .op-no { font-size: 24px; }
  .op-type { padding: 3px 14px; font-size: 24px; }
  .op-arrow { margin-left: 14px; font-size: 26px; }
  .op-cat { margin-top: 14px; font-size: 30px; }
  .op-quantity { margin-top: 13px; }
  .op-quantity strong { font-size: 32px; }
  .op-chip { padding: 6px 14px; font-size: 24px; }

  .op-empty { padding: 110px 22px 130px; }
  .op-empty .empty-icon { font-size: 60px; }
  .op-empty p { font-size: 26px; }
  .op-empty span { font-size: 24px; }
}
</style>
